import {
  Backdrop,
  Box,
  Button,
  Divider,
  Drawer,
  FormControlLabel,
  IconButton,
  Link,
  makeStyles,
  MenuItem,
  Snackbar,
  Switch,
  TextField,
  Typography,
} from "@material-ui/core";
import { CloseRounded, Settings } from "@material-ui/icons";
import { Alert } from "@material-ui/lab";
import { UiActions } from "globalUI";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { connect } from "react-redux";
import { withRouter } from "react-router";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer - 1,
    color: "#fff",
  },
  button: {
    marginRight: theme.spacing(4),
    marginTop: theme.spacing(2),
    textTransform: "none",
  },
}));

const verificationSettings = [
  { value: "smartName", label: "Smart Name Verification" },
  { value: "name", label: "Name Verification" },
  { value: "gender", label: "Gender  Verification" },
  { value: "yob", label: "Year of Birth Verification" },
  { value: "pinCode", label: "Pin Code Verification" },
  { value: "state", label: "State Verification" },
  { value: "title", label: "Title Verification" },
];

const Signature = () => {
  const classes = useStyles();
  const [successAlert, setSuccessAlert] = useState(false);

  const [aadhaarSettings, setAadhaarSettings] = useState(false);
  const [textTypeSettings, setTextTypeSettings] = useState(false);

  const { handleSubmit, watch, control, setValue } = useForm({
    defaultValues: {},
    mode: "onBlur",
  });

  const aadhaar = watch("aadhaar");
  const virtual = watch("virtual");

  useEffect(() => {
    setValue("aadhaarSign.otp.value", aadhaar);
    setValue("aadhaarSign.biometric.value", aadhaar);
    setValue("aadhaarSign.iris.value", aadhaar);
  }, [aadhaar]);

  useEffect(() => {
    setValue("virtualSign.textType.value", virtual);
    setValue("virtualSign.drawType", virtual);
  }, [virtual]);

  const onSubmit = (data) => {
    // console.log(data);
    setSuccessAlert(true);
  };

  return (
    <>
      <Snackbar
        open={successAlert}
        autoHideDuration={3000}
        onClose={() => setSuccessAlert(false)}
      >
        <Alert onClose={() => setSuccessAlert(false)} severity="success">
          User info updated successfully.
        </Alert>
      </Snackbar>
      <Box mt={3} mb={2}>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          Manage your Allowed eSignatures here!
        </Typography>
      </Box>
      <Divider />
      <Backdrop
        className={classes.backdrop}
        open={aadhaarSettings}
        onClick={() => setAadhaarSettings(false)}
      />
      <Drawer
        anchor="right"
        variant="persistent"
        classes={{ paperAnchorDockedRight: "no-border-drawer" }}
        open={aadhaarSettings}
        onClose={() => setAadhaarSettings(false)}
      >
        <Box width={600} role="presentation">
          <Box
            position="sticky"
            top={0}
            zIndex={10}
            display="flex"
            py={1}
            px={2}
            justifyContent="space-between"
            alignItems="center"
            bgcolor="primary.main"
            color="primary.contrastText"
          >
            <Typography variant="h5">
              Aadhaar eSign Verification Settings
            </Typography>
            <IconButton
              onClick={() => setAadhaarSettings(false)}
              style={{ color: "white" }}
            >
              <CloseRounded />
            </IconButton>
          </Box>
          <Divider />
          <Box p={2} pt={4}>
            <Box m={1} display="flex" justifyContent="space-between">
              <Typography variant="caption">Verifiation Type</Typography>
              <Typography variant="caption">Acceptance Percentage</Typography>
              <Typography variant="caption">Acceptance Condition</Typography>
            </Box>
            <Divider />
            {verificationSettings.map((item, idx) => (
              <React.Fragment key={idx}>
                <Box
                  m={1}
                  my={2}
                  display="flex"
                  alignItems="center"
                  style={{ gap: 30 }}
                >
                  <Typography variant="body1" style={{ flex: 2 }}>
                    {item.label}
                  </Typography>
                  {item.value === "smartName" ? (
                    <Controller
                      render={({ onChange, onBlur, value, ref }, {}) => (
                        <TextField
                          size="small"
                          variant="outlined"
                          type="number"
                          style={{ flex: 1 }}
                          onBlur={onBlur}
                          onChange={(e) => onChange(e.target.value)}
                          value={value}
                          inputRef={ref}
                          InputProps={{ inputProps: { min: 1, max: 100 } }}
                        />
                      )}
                      control={control}
                      name={`aadharSettings.${item.value}.percentage`}
                      defaultValue={50}
                    />
                  ) : (
                    <div style={{ flex: 1 }}> </div>
                  )}
                  <Controller
                    render={({ onChange, onBlur, value, ref }, {}) => (
                      <TextField
                        size="small"
                        variant="outlined"
                        style={{ flex: 2 }}
                        select
                        onBlur={onBlur}
                        onChange={(e) => onChange(e.target.value)}
                        value={value}
                        inputRef={ref}
                      >
                        <MenuItem value="reject">Reject if Failed</MenuItem>
                        <MenuItem value="accept">
                          Accept but respond with Result
                        </MenuItem>
                      </TextField>
                    )}
                    control={control}
                    name={`aadharSettings.${item.value}.condition`}
                    defaultValue={"reject"}
                  />
                </Box>
                <Divider />
              </React.Fragment>
            ))}
          </Box>
        </Box>
      </Drawer>

      <Box
        my={2}
        mx={1}
        width={"50%"}
        display="flex"
        flexDirection="column"
        style={{ gap: 10 }}
      >
        <Controller
          render={({ onChange, onBlur, value, ref }) => (
            <FormControlLabel
              control={
                <Switch
                  onBlur={onBlur}
                  onChange={(e) => onChange(e.target.checked)}
                  checked={value ?? false}
                  inputRef={ref}
                />
              }
              label={
                <Box display="flex" alignItems="center">
                  <Typography>Aadhaar &nbsp; </Typography>
                  <IconButton onClick={() => setAadhaarSettings(true)}>
                    {" "}
                    <Settings fontSize="small" />
                  </IconButton>
                </Box>
              }
            />
          )}
          control={control}
          name={`aadhaar`}
          defaultValue={false}
        />
        <Box mx={6} display="flex" justifyContent="space-between">
          <Controller
            render={({ onChange, onBlur, value, ref }) => (
              <FormControlLabel
                control={
                  <Switch
                    size="small"
                    onBlur={onBlur}
                    onChange={(e) => onChange(e.target.checked)}
                    checked={value ?? false}
                    inputRef={ref}
                  />
                }
                label=" OTP"
              />
            )}
            control={control}
            name={`aadhaarSign.otp.value`}
            defaultValue={false}
          />
          <Controller
            render={({ onChange, onBlur, value, ref }) => (
              <FormControlLabel
                control={
                  <Switch
                    size="small"
                    onBlur={onBlur}
                    onChange={(e) => onChange(e.target.checked)}
                    checked={value ?? false}
                    inputRef={ref}
                  />
                }
                label=" Default"
              />
            )}
            control={control}
            name={`aadhaarSign.otp.default`}
            defaultValue={false}
          />
        </Box>
        <Box mx={6} display="flex" justifyContent="space-between">
          <Controller
            render={({ onChange, onBlur, value, ref }) => (
              <FormControlLabel
                control={
                  <Switch
                    size="small"
                    onBlur={onBlur}
                    onChange={(e) => onChange(e.target.checked)}
                    checked={value ?? false}
                    inputRef={ref}
                  />
                }
                label=" Biometric"
              />
            )}
            control={control}
            name={`aadhaarSign.biometric.value`}
            defaultValue={false}
          />
          <Controller
            render={({ onChange, onBlur, value, ref }) => (
              <FormControlLabel
                control={
                  <Switch
                    size="small"
                    onBlur={onBlur}
                    onChange={(e) => onChange(e.target.checked)}
                    checked={value ?? false}
                    inputRef={ref}
                  />
                }
                label=" Default"
              />
            )}
            control={control}
            name={`aadhaarSign.biometric.default`}
            defaultValue={false}
          />
        </Box>
        <Box mx={6} display="flex" justifyContent="space-between">
          <Controller
            render={({ onChange, onBlur, value, ref }) => (
              <FormControlLabel
                control={
                  <Switch
                    size="small"
                    onBlur={onBlur}
                    onChange={(e) => onChange(e.target.checked)}
                    checked={value ?? false}
                    inputRef={ref}
                  />
                }
                label=" IRIS"
              />
            )}
            control={control}
            name={`aadhaarSign.iris.value`}
            defaultValue={false}
          />
          <Controller
            render={({ onChange, onBlur, value, ref }) => (
              <FormControlLabel
                control={
                  <Switch
                    size="small"
                    onBlur={onBlur}
                    onChange={(e) => onChange(e.target.checked)}
                    checked={value ?? false}
                    inputRef={ref}
                  />
                }
                label=" Default"
              />
            )}
            control={control}
            name={`aadhaarSign.iris.default`}
            defaultValue={false}
          />
        </Box>
        <br />
        <Box display="flex" justifyContent="space-between">
          <Controller
            render={({ onChange, onBlur, value, ref }) => (
              <FormControlLabel
                control={
                  <Switch
                    onBlur={onBlur}
                    onChange={(e) => onChange(e.target.checked)}
                    checked={value ?? false}
                    inputRef={ref}
                  />
                }
                label=" Virtual Sign"
              />
            )}
            control={control}
            name={`virtual`}
            defaultValue={false}
          />
          <Controller
            render={({ onChange, onBlur, value, ref }) => (
              <FormControlLabel
                control={
                  <Switch
                    size="small"
                    onBlur={onBlur}
                    onChange={(e) => onChange(e.target.checked)}
                    checked={value ?? false}
                    inputRef={ref}
                  />
                }
                label=" Default"
              />
            )}
            control={control}
            name={`virtualSign.default`}
            defaultValue={false}
          />
        </Box>
        <Box mx={6}>
          <Controller
            render={({ onChange, onBlur, value, ref }) => (
              <FormControlLabel
                control={
                  <Switch
                    size="small"
                    onBlur={onBlur}
                    onChange={(e) => onChange(e.target.checked)}
                    checked={value ?? false}
                    inputRef={ref}
                  />
                }
                label=" Draw Type"
              />
            )}
            control={control}
            name={`virtualSign.drawType`}
            defaultValue={false}
          />
        </Box>
        <Box mx={6} mb={1}>
          <Controller
            render={({ onChange, onBlur, value, ref }) => (
              <FormControlLabel
                control={
                  <Switch
                    size="small"
                    onBlur={onBlur}
                    onChange={(e) => onChange(e.target.checked)}
                    checked={value ?? false}
                    inputRef={ref}
                  />
                }
                label={
                  <Box display="flex" alignItems="center">
                    <Typography>Text Type &nbsp; </Typography>
                    <IconButton onClick={() => setTextTypeSettings(true)}>
                      {" "}
                      <Settings fontSize="small" />
                    </IconButton>
                  </Box>
                }
              />
            )}
            control={control}
            name={`virtualSign.textType.value`}
            defaultValue={false}
          />
        </Box>
        <Typography variant="body2">
          <b>Note:</b> You have restricted 2 virtual sign style.{" "}
          <Link onClick={() => setTextTypeSettings(true)}>click here</Link> for
          edit style.
        </Typography>
      </Box>
      <Backdrop
        className={classes.backdrop}
        open={textTypeSettings}
        onClick={() => setTextTypeSettings(false)}
      />
      <Drawer
        anchor="right"
        variant="persistent"
        classes={{ paperAnchorDockedRight: "no-border-drawer" }}
        open={textTypeSettings}
        onClose={() => setTextTypeSettings(false)}
      >
        <Box width={400} role="presentation">
          <Box
            position="sticky"
            top={0}
            zIndex={10}
            display="flex"
            py={1}
            px={2}
            justifyContent="space-between"
            alignItems="center"
            bgcolor="primary.main"
            color="primary.contrastText"
          >
            <Typography variant="h5"> Virtual Sign Settings </Typography>
            <IconButton
              onClick={() => setTextTypeSettings(false)}
              style={{ color: "white" }}
            >
              <CloseRounded />
            </IconButton>
          </Box>
          <Divider />
          <Box p={3}>
            <Typography>Restrict Virtual Sign Style for Signer</Typography>
            <br />
            <Controller
              render={({ onChange, onBlur, value, ref }) => (
                <FormControlLabel
                  control={
                    <Switch
                      onBlur={onBlur}
                      onChange={(e) => onChange(e.target.checked)}
                      checked={value ?? false}
                      inputRef={ref}
                    />
                  }
                  label={
                    <>
                      <img src={IMG} />
                    </>
                  }
                />
              )}
              control={control}
              name={`virtualSign.textType.type1`}
              defaultValue={true}
            />
            <br />
            <Controller
              render={({ onChange, onBlur, value, ref }) => (
                <FormControlLabel
                  control={
                    <Switch
                      onBlur={onBlur}
                      onChange={(e) => onChange(e.target.checked)}
                      checked={value ?? false}
                      inputRef={ref}
                    />
                  }
                  label={
                    <>
                      <img src={IMG2} />
                    </>
                  }
                />
              )}
              control={control}
              name={`virtualSign.textType.type2`}
              defaultValue={true}
            />
          </Box>
        </Box>
      </Drawer>
      <Divider />
      <Button
        variant="contained"
        color="primary"
        className={classes.button}
        onClick={handleSubmit(onSubmit)}
      >
        Update
      </Button>
    </>
  );
};

const IMG =
  "data:image/png;base64,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";
const IMG2 =
  "data:image/png;base64,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";

const mapStateToProps = (state) => ({
  createData: state.ui.createData,
  inviteeData: state.ui.inviteData,
});

const mapDispatchToProps = {
  setCreateData: UiActions.setCreateData,
  setInviteeData: UiActions.setInviteData,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Signature)
);
